import * as React from "react";
import { Footer } from "../../../layout/footer";
import "./index.scss";
import { Button } from "antd";
import { useAppSelector } from "../../../store/hooks";

interface Props {
  devOnlyMessage?: string;
}
export const ErrorPage: React.FC<Props> = ({ devOnlyMessage = "" }) => {
  const theme = useAppSelector((state) => state.theme.theme);

  return (
    <>
      <div className={`error-page-container`}>
        <div className="error-page-header">
          <img
            onClick={() => window.location.replace("/")}
            src={`/resources/logos/controlPlaneLogo${theme === "dark" ? "White" : ""}.svg`}
          />
        </div>
        <div className="error-page">
          <div className="error-page-content">
            <div className="error-page-content-title">
              <span className="">
                We are sorry. This error has been logged and will be investigated. Please retry later.
              </span>
            </div>
            {devOnlyMessage ? <span className="error-page-content-message">{devOnlyMessage}</span> : null}
            <Button type={"primary"} onClick={() => window.location.replace("/")}>
              Go Back
            </Button>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
